export const ExperimentAPINames = {
  HigherPaywall: "Higher Paywall",
  PaywallMasking: "Paywall Masking",
  SubNavTrendingLabel: "SubNav Trending Label",
  VelocityWallThreshold: "Velocity Wall Threshold",
};
